// src/services/companySettingsService.js
import api from './api';

const companySettingsService = {
  // Get all company settings
  getAllSettings: async () => {
    const response = await api.get('/admin/settings');
    return response.data;
  },

  // Get specific setting
  getSetting: async (key) => {
    const response = await api.get(`/admin/settings/${key}`);
    return response.data;
  },

  // Update setting
  updateSetting: async (key, data) => {
    const response = await api.put(`/admin/settings/${key}`, data);
    return response.data;
  },

  // Toggle feature
  toggleFeature: async (key) => {
    const response = await api.post(`/admin/settings/${key}/toggle`);
    return response.data;
  },

  // Get enabled features for current user (public endpoint)
  getEnabledFeatures: async () => {
    const response = await api.get('/features');
    return response.data;
  }
};

export default companySettingsService;
